import { NavLink as Link } from "react-router-dom";

const Footer = () => {

  return (
    <footer className="bridge-refined-footer">
      <div className="container">
        <div className="bridge-refined-shell">
          <div className="bridge-refined-main">
            <div className="bridge-refined-brand">
              <Link to="./" className="navbar-brand bridge-refined-logo">
                <img src="/images/logo.png" className="img-fluid dl" alt="Trust Bitcoin" />
                <img src="/images/logo-light.png" className="img-fluid dd" alt="Trust Bitcoin" />
              </Link>

              <div className="bridge-refined-brand-copy">
                <p className="mb-0">Cross-chain asset bridge for the Trust Bitcoin ecosystem.</p>
                <span>Secure • Transparent • Non-Custodial</span>
              </div>
            </div>

            <div className="bridge-refined-column">
              <h4 className="text-white">Products</h4>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/about"><p className="mb-0">Trust Bitcoin Blockchain</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/tbc-coin"><p className="mb-0">Trust Bitcoin Coin (TBC)</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/wrapped-trust-bitcoin"><p className="mb-0">WTBC</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/ausd"><p className="mb-0">AUSD</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/travel-utility-trustbitcoin"><p className="mb-0">Travel Utility</p></a></div>
              <div className="linF2"><a href="https://bridge.trustbitcoin.io/"><p className="mb-0">Trust Bitcoin Bridge</p></a></div>
            </div>

            <div className="bridge-refined-column">
              <h4 className="text-white">Transparency</h4>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/"><p className="mb-0">Network Explorer</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/"><p className="mb-0">Smart Contracts</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/"><p className="mb-0">Supply Transparency</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/"><p className="mb-0">Treasury Transparency</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/"><p className="mb-0">Bridge Transactions</p></a></div>
            </div>

            <div className="bridge-refined-column">
              <h4 className="text-white">Legal</h4>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/terms"><p className="mb-0">Terms of Use</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/privacypolicy"><p className="mb-0">Privacy Policy</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/risk-disclosure"><p className="mb-0">Risk Disclosure</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/risk-statement"><p className="mb-0">Compliance &amp; Risk Disclosure</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/user-agreement"><p className="mb-0">User Agreement</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/legal-disclousure"><p className="mb-0">Legal Disclousure</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/treasury-disclaimer"><p className="mb-0">Treasury Disclaimer</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/inter-company-relationship"><p className="mb-0">Inter Company Relationship</p></a></div>
            </div>

            <div className="bridge-refined-column">
              <h4 className="text-white">Community</h4>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/participate-trustbitcoin"><p className="mb-0">Participate in Trust Bitcoin</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/community-ethics"><p className="mb-0">Community &amp; Ethics</p></a></div>
              <div className="linF2"><a target="_blank" rel="noreferrer" href="https://trustbitcoin.io/press-media"><p className="mb-0">Press &amp; Media</p></a></div>
            </div>
          </div>

          <div className="bridge-refined-entities">
            <div className="bridge-refined-entity">
              <p className="bridge-refined-label mb-0">Protocol Governance</p>
              <p className="mb-0"><b>Trust Bitcoin DAO LLC</b></p>
              <p className="mb-0">30 N Gould St Ste R, Sheridan, Wyoming 82801, USA</p>
            </div>
            <div className="bridge-refined-entity">
              <p className="bridge-refined-label mb-0">Technology &amp; Software Infrastructure</p>
              <p className="mb-0"><b>TBC Digital Labs FZCO</b></p>
              <p className="mb-0">Dubai, United Arab Emirates</p>
            </div>
            <div className="bridge-refined-entity">
              <p className="bridge-refined-label mb-0">Ecosystem Treasury Operations</p>
              <p className="mb-0"><b>TBC Tech Community Ltd</b></p>
              <p className="mb-0">British Virgin Islands</p>
            </div>
          </div>

          <div className="bridge-refined-info">
            <p className="mb-0">The Trust Bitcoin ecosystem includes separate entities performing defined governance, technology and treasury-related functions. Please review the Inter-Company Relationship disclosure for further information.</p>
            <p className="mb-0">Technology and Blockchain Platform Service Provider specializing in Non-Custodial Wallet Infrastructure and Web3 Application Development.</p>
          </div>

          <div className="bridge-refined-bottom">
            
            <p className="f12 mb-0">© 2026 TRUST BITCOIN ALL RIGHTS RESERVED</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
